import * as React from "react";

import CompanyIncorporation from 'src/containers/3a-companyIncorporation/companyIncorporation';

export default () => {
  return <CompanyIncorporation />;
}